export const manageCookies = {
  get(name: string): string | null {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);

    if (parts.length === 2) {
      return decodeURIComponent(parts.pop()?.split(";").shift() ?? "");
    }
    return null; // Return null if the cookie doesn't exist
  },

  set(name: string, value: string, expireDate: string): void {
    const expires = "expires=" + expireDate;

    document.cookie = name + "=" + value + ";" + expires + ";path=/";
    // document.cookie = name + "=" + value;
  },

  remove(name: string, expireDate: string): void {
    this.set(name, "", expireDate);
  },

  exists(name: string): boolean {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    return parts.length === 2;
  },
};
